import { z } from "zod";
import { EpochMsSchema } from "../primitives";

/** `GET /api/health` — unauthenticated liveness probe. */
export const HealthResponseSchema = z.object({
  status: z.literal("ok"),
  time: EpochMsSchema,
  environment: z.string(),
  version: z.string().optional(),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
